//interfaces
import { IFormResponse } from "@/interfaces/activityFeedNotifications";
import { UserActivity } from "@/interfaces/activityFeed";

//components
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import ContentTitle from "../../elements/contentTitle/ContentTitle";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import FormResponseTitle from "../../elements/notificationTitle/FormResponseTitle/FormResponseTitle";

//hooks
import { useFormResponse } from "./FormResponse.hooks";

//styling
import "../../../../../css/activityFeed/notifications/form-response-activity.scss";



const FormResponse = ({zIndexNum, isPopOut = false, timeStamp, dateStamp, user, parentList, onDownloadCSVClick, content, appDetails}: IFormResponse) => {
    const {screenClassName, showDeletedBanner, downloadCSVLink, activityInfo} = useFormResponse({isPopOut, timeStamp, dateStamp, parentList, onDownloadCSVClick, content, appDetails});

    return (
        <div className={`${isPopOut ? "" : "form-response-full"} form-response notification-wrapper`}>
            <div className="top-row">
                <ActivityProfileData 
                    imageUrl={user.imageUrl}
                    isPopOut={isPopOut}
                    userActivity={UserActivity.formResponse} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                />
                
                <FormResponseTitle 
                    user={user.name} 
                    isPopOut={isPopOut}
                />
            </div>        

            <ContentTitle 
                zIndexNum={zIndexNum} 
                className={screenClassName} 
                contentTitle={content.title} 
                onDownloadCSVClick={downloadCSVLink} 
            />
                
            <DeletedBanner 
                isDeleted={showDeletedBanner} 
                message={"Content Archived"}
            />

            <ActivityInformationPanel 
                {...activityInfo} 
            />
        </div>
    )
};

export default FormResponse